import {Icon} from '@ezcater/tapas';
import {faStore, faUtensils} from '@fortawesome/pro-regular-svg-icons';
import Image from 'next/image';
import {twMerge} from 'tailwind-merge';

import {type PartialTypeaheadResult} from '@/components/global/layout/AppBar/SearchBar/types';
import {TypeaheadDocType} from '@/graphql/types';

type WhatTypeaheadOptionProps = {
  id: string;
  isActive?: boolean;
  onSelect: () => void;
  result: PartialTypeaheadResult;
};

const WhatTypeaheadOption: React.FC<WhatTypeaheadOptionProps> = ({
  id,
  isActive = false,
  onSelect,
  result,
}) => {
  const isCaterer = result.type === TypeaheadDocType.Caterer;

  return (
    <button
      aria-selected={isActive}
      className={twMerge(
        'flex w-full items-center gap-3 rounded-lg px-2 py-2 text-left text-peppercorn-800 hover:bg-peppercorn-50',
        isActive && 'bg-peppercorn-100',
      )}
      data-testid={isCaterer ? 'what-typeahead-caterer-option' : 'what-typeahead-keyword-option'}
      id={id}
      onClick={onSelect}
      onMouseDown={event => event.preventDefault()}
      role="option"
      tabIndex={-1}
      type="button"
    >
      {isCaterer ? (
        <Image
          alt=""
          className="h-11 w-11 rounded-lg border border-peppercorn-100 bg-white object-contain p-0.5"
          data-chromatic="ignore"
          height={40}
          src={`${__DEV__ ? 'https://www.ezcater.com' : ''}/db_images/show_img/${result.logoImageId}`}
          width={40}
        />
      ) : (
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-peppercorn-100 text-lg text-peppercorn-800">
          <Icon
            aria-hidden
            icon={result.type === TypeaheadDocType.Diversity ? faStore : faUtensils}
          />
        </span>
      )}
      <span className="truncate">{result.display}</span>
    </button>
  );
};

export default WhatTypeaheadOption;
